var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2244,
    height: 174,
    viewBox: "0 0 2244 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shelf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill 1",
    filter: "url(#filter0_f_0_629)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2148.56 99C2148.56 99 1536.68 119 1122.7 119C708.717 119 95.0332 99 95.0332 99L55.0332 56H2188.56L2148.56 99Z",
    fill: "#333333",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 76H2196V36H36V76Z",
    fill: "#8A5253"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 122H102V76H76V122Z",
    fill: "#8A5253"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 88H102V76H76V88Z",
    fill: "#5A2E2F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2130 122H2156V76H2130V122Z",
    fill: "#8A5253"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2130 88H2156V76H2130V88Z",
    fill: "#5A2E2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_629",
    x: 0.667568,
    y: 1.63437,
    width: 2242.25,
    height: 171.731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5914,
    result: "effect1_foregroundBlur_0_629"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelf);
export default __webpack_public_path__ + "static/media/shelf.bd12d8a1faadbe352e702bcdfc12a8ae.svg";
export { ForwardRef as ReactComponent };